import BreadcrumbsBar from './BreadcrumbsBar';

export default BreadcrumbsBar;

export { type BreadcrumbItem } from './types';
